import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propId } from '../../../helpers/custom-prop-types';
import StarIcon from '../../Icon/Svg/StarIcon';
import SubmitButton from '../../Ui/Button/SubmitButton';
const FavoriteColumnBox = (props) => {
    const { hasFavorite, loadingFavorite, onCreateFavorite, onDeleteFavorite, value, } = props;
    return (_jsx("div", Object.assign({ className: 'column_content_favorite' }, { children: _jsx(SubmitButton, { buttonType: 'button', className: `favorite_button button center no-shadow ${hasFavorite ? 'has_favorite' : ''}`, isDisabled: loadingFavorite, isLoading: loadingFavorite, onControlClick: hasFavorite ? onDeleteFavorite : onCreateFavorite, text: _jsxs(_Fragment, { children: [_jsx(StarIcon, { className: `yellow ${hasFavorite ? 'fill' : ''}` }), _jsx("span", { children: hasFavorite ? 'マイページ保存中' : 'マイページに保存する' })] }), value: value }) })));
};
FavoriteColumnBox.propTypes = {
    hasFavorite: propBool().isRequired,
    loadingFavorite: propBool().isRequired,
    onCreateFavorite: propFunc().isRequired,
    onDeleteFavorite: propFunc().isRequired,
    value: propId().isRequired,
};
export default FavoriteColumnBox;
